import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { approveApprovalRequest } from '~/services/LuxLoyalty';

import { claimsQueryKeys } from './claimsQueryKeys';

export function useApproveRequest(campaignId: string) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: ({ requestId, notes }: { requestId: string; notes?: string }) =>
      approveApprovalRequest(requestId, { notes }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: claimsQueryKeys.approvalRequestsBase(campaignId) });
      enqueueSnackbar('Request approved successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error approving request: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
